export default __webpack_public_path__ + "static/media/schedule-icon.3c4b81ab.svg";